namespace GeniuzPOS.QRreport {
    export interface QRyReportRefundReasonByBillForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        PosId: Serenity.LookupEditor;
        CashierId: Serenity.LookupEditor;
        SalemanId: Serenity.LookupEditor;
        MbId: Serenity.LookupEditor;
        GruopType: Serenity.LookupEditor;
    }

    export class QRyReportRefundReasonByBillForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRyReportRefundReasonByBill';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRyReportRefundReasonByBillForm.init)  {
                QRyReportRefundReasonByBillForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRyReportRefundReasonByBillForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'PosId', w0,
                    'CashierId', w0,
                    'SalemanId', w0,
                    'MbId', w0,
                    'GruopType', w0
                ]);
            }
        }
    }
}
